import { Form, Header } from '@mairistem/composants';

type TypeProps = {
  type: 'facture' | 'payeur';
  header: string;
  subheader: string;
  disabled?: boolean | 'payeur' | 'facture';
  onTypeChange: (e: any, { value }: { value: 'facture' | 'payeur' }) => void;
};

const Type = (props: TypeProps) => {
  const { header, subheader, disabled, type, onTypeChange } = props;

  return (
    <>
      <Header as="h3">
        <Header.Content>
          {header}
          <Header.Subheader style={{ marginTop: '0.5em' }}>{subheader}</Header.Subheader>
        </Header.Content>
      </Header>
      &nbsp;
      <Form.Group
        as={Header}
        style={{
          display: 'flex',
          marginLeft: 'auto',
        }}
      >
        <Form.Radio
          label="par facture"
          value="facture"
          checked={type === 'facture'}
          onChange={onTypeChange}
          style={{ margin: 0 }}
          disabled={disabled === true || disabled === 'facture'}
        />
        <Form.Radio
          label="par payeur"
          value="payeur"
          checked={type === 'payeur'}
          onChange={onTypeChange}
          style={{ margin: 0 }}
          disabled={disabled === true || disabled === 'payeur'}
        />
      </Form.Group>
    </>
  );
};

export default Type;
